import React from 'react';
import {IMaskInput} from "react-imask";

interface PhoneMaskedInputProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}

const PhoneMaskedInput = React.forwardRef<HTMLElement, PhoneMaskedInputProps>(
    function PhoneInput(props, ref) {
        const { onChange, ...other } = props;
        return (
            <IMaskInput
                {...other}
                mask="+38\0 (#0) 000-0000"
                definitions={{
                    '#': /[0-9]/,
                }}
                inputRef={ref as any}
                onAccept={(value: any) => onChange({ target: { name: props.name, value: value.replace(/\(|\)|-|\s/g, '') } })}
                overwrite
            />
        );
    },
);

export default PhoneMaskedInput;
